import { useIntl } from 'react-intl';
import { BtlBaseForm } from '../../BtlBaseForm';
import { makeFormReadonly } from '../../makeFormReadonly';
import { addressFormSchema } from './formSchema';
import { useAddressFormProps } from './useAddressFormProps';

export const Address = ({ isEditable }: { isEditable?: boolean }) => {
  const { formatMessage } = useIntl();
  const addressProps = useAddressFormProps();

  const formSchema = addressFormSchema({ formatMessage, ...addressProps });

  const transformedFormSchema = !isEditable ? makeFormReadonly(formSchema) : formSchema;

  return <BtlBaseForm layoutType={'Embed'} columns={transformedFormSchema} grid={true} />;
};
